/* eslint-disable @next/next/no-img-element */
import { getStrapiMedia } from "@/utils/media";
import Image from "next/image";
import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { imageLocalization } from "@/utils/helpers";
import { GlobalContext } from "@/components/context/Global";

const WhyChoose = ({ data }: any) => {
  const { userCountry } = useContext<any>(GlobalContext);

  const getImage = (datas: any) => {
    const localizationImg = imageLocalization[userCountry];
    if (datas?.LocalizationImages && localizationImg) {
      const ImageExists = datas?.LocalizationImages[localizationImg];
      if (ImageExists?.data) {
        return (
          <>
            <Image
              src={getStrapiMedia(ImageExists)}
              width={data?.Image?.data?.attributes?.width}
              height={data?.Image?.data?.attributes?.height}
              priority={false}
              alt={data?.Image?.data?.attributes?.alternativeText || data?.Title}
              style={{ objectFit: "contain" }}
              className="img-fluid"
            />
          </>
        );
      }
      else {
        return (
          <>
            <Image
              src={getStrapiMedia(data?.Image)}
              width={data?.Image?.data?.attributes?.width}
              height={data?.Image?.data?.attributes?.height}
              priority={false}
              alt={data?.Image?.data?.attributes?.alternativeText || data?.Title}
              style={{ objectFit: "contain" }}
              className="img-fluid"
            />
          </>
        );
      }
    } else {
      return (
        <>
          <Image
            src={getStrapiMedia(data?.Image)}
            width={data?.Image?.data?.attributes?.width}
            height={data?.Image?.data?.attributes?.height}
            priority={false}
            alt={data?.Image?.data?.attributes?.alternativeText || data?.Title}
            style={{ objectFit: "contain" }}
            className="img-fluid"
          />
        </>
      );
    }
  };
  return (
    <div className="why-choose">
      <Container>
        <Row>
          <Col lg={5}>
            <h2 className="why-choose-heading heading mb-4">{data?.Title}</h2>
          </Col>
        </Row>
        <Row className="align-items-end justify-content-between">
          <Col lg={5}>
            <p className="normal-text case-mb-4">{data?.ShortDescription}</p>
            {getImage(data)}
          </Col>
          {data?.Collections && (
            <Col lg={6} className="mt-md-5 mt-lg-0">
              {data?.Collections.map((item: any, index: number) => (
                <div key={index}>
                  <div className="single">
                    <h4>{item?.Title}</h4>
                    <p className="normal-text">{item?.SubTitle}</p>
                  </div>
                  {index !== data?.Collections.length - 1 && (
                    <div className="line"></div>
                  )}
                </div>
              ))}
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default WhyChoose;
